var styles = {"layer_title":"LayerTitle-module_layer_title__uvHnE","align-left":"LayerTitle-module_align-left__6L8wm","title":"LayerTitle-module_title__NUrhL","count":"LayerTitle-module_count__mdaWB"};

export { styles as default };
